/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedRequestHold_item = {
    readonly isAuctionEnabled: boolean | null;
    readonly hasRequestedHoldForBuyer?: boolean | null | undefined;
    readonly displayInfo?: {
        readonly ctas: {
            readonly showHoldRequest: boolean | null;
        } | null;
    } | null | undefined;
    readonly " $refType": "PdpSharedRequestHold_item";
};
export type PdpSharedRequestHold_item$data = PdpSharedRequestHold_item;
export type PdpSharedRequestHold_item$key = {
    readonly " $data"?: PdpSharedRequestHold_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedRequestHold_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedRequestHold_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            (v0/*: any*/)
          ],
          "kind": "ScalarField",
          "name": "hasRequestedHoldForBuyer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            (v0/*: any*/),
            {
              "kind": "Literal",
              "name": "page",
              "value": "pdp"
            }
          ],
          "concreteType": "ItemDisplayInfo",
          "kind": "LinkedField",
          "name": "displayInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CTADisplay",
              "kind": "LinkedField",
              "name": "ctas",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showHoldRequest",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '2b8ad84dc0c70010033f22c0ceb4fe08';
export default node;
